import checkPermissions from './checkPermissions'
import formatDate from './formatDate'
import mouseEvents from './MouseEvents'
import showViewport from './showViewport'
import phoneFormat from './phoneFormat'
import state from './state'
import onMountedDataProvider from './onMountedDataProvider'

export default {
    "checkPermissions":checkPermissions,
    "formatDate":formatDate,
    "mouseEvents":mouseEvents,
    "showViewport": showViewport,
    "phoneFormat": phoneFormat,
    "state": state,
    "onMountedDataProvider": onMountedDataProvider
}